import React, { useState } from 'react';
import supabase from '../../supabase/supabase';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiShoppingBag, FiCalendar, FiDollarSign, FiLock, FiMessageSquare } = FiIcons;
const TABLE_NAME = 'expenses_1739880000000';

const EditExpenseModal = ({ expense, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    supplier: expense.supplier,
    purchase_date: expense.purchase_date,
    amount: expense.amount,
    remarks: expense.remarks || ''
  });
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== 'Subic@123') {
      setError('Incorrect password. Access denied.');
      return;
    }

    setIsSubmitting(true);
    try {
      const { error: updateError } = await supabase
        .from(TABLE_NAME)
        .update({
          supplier: formData.supplier,
          purchase_date: formData.purchase_date,
          amount: parseFloat(formData.amount),
          remarks: formData.remarks
        })
        .eq('id', expense.id);

      if (updateError) throw updateError;
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
          <h3 className="text-xl font-bold text-gray-900">Edit Expense</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors">
            <SafeIcon icon={FiX} className="text-gray-500" />
          </button>
        </div>

        <form onSubmit={handleUpdate} className="p-6 space-y-4">
          {error && <div className="p-3 bg-red-50 text-red-600 rounded-lg text-sm border border-red-100">{error}</div>}
          
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Supplier</label>
            <div className="relative">
              <SafeIcon icon={FiShoppingBag} className="absolute left-3 top-3 text-gray-400" />
              <input 
                type="text" required
                className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-xl focus:ring-emerald-500"
                value={formData.supplier}
                onChange={(e) => setFormData({...formData, supplier: e.target.value})}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Date</label>
              <div className="relative">
                <SafeIcon icon={FiCalendar} className="absolute left-3 top-3 text-gray-400" />
                <input 
                  type="date" required
                  className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-xl focus:ring-emerald-500"
                  value={formData.purchase_date}
                  onChange={(e) => setFormData({...formData, purchase_date: e.target.value})}
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Amount</label>
              <div className="relative">
                <SafeIcon icon={FiDollarSign} className="absolute left-3 top-3 text-gray-400" />
                <input 
                  type="number" step="0.01" required
                  className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-xl focus:ring-emerald-500"
                  value={formData.amount}
                  onChange={(e) => setFormData({...formData, amount: e.target.value})}
                />
              </div>
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Remarks</label>
            <div className="relative">
              <SafeIcon icon={FiMessageSquare} className="absolute left-3 top-3 text-gray-400" />
              <textarea 
                rows="2"
                className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-xl focus:ring-emerald-500"
                value={formData.remarks}
                onChange={(e) => setFormData({...formData, remarks: e.target.value})}
              ></textarea>
            </div>
          </div>

          <div className="pt-4 border-t border-gray-100">
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1 text-red-600">Admin Password Required</label>
            <div className="relative">
              <SafeIcon icon={FiLock} className="absolute left-3 top-3 text-gray-400" />
              <input 
                type="password" required
                placeholder="Confirm with Subic@123"
                className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-xl focus:ring-blue-500"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="flex space-x-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 py-2.5 px-4 bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200">
              Cancel
            </button>
            <button type="submit" disabled={isSubmitting} className="flex-2 py-2.5 px-6 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 disabled:opacity-50">
              {isSubmitting ? 'Updating...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditExpenseModal;